import { ApiRoute } from 'config';
import { NotificationsContext, ContextValue } from 'contexts/Notifications';
import createUseContextHook from './createUseContextHook';

const useNotifications = createUseContextHook<ContextValue>(
  // @ts-expect-error TODO: fix null safety
  NotificationsContext,
  ApiRoute.NOTIFICATIONS,
);

export default useNotifications;
